module.exports = __webpack_public_path__ + "img/contact-phone.8fa700a6.svg";